<template>
  <span>
  "EQUIPO
  <span v-if="filteredTeams.length">{{filteredTeams[0].name}}</span> -
  <span v-if="filteredAccounts.length">{{filteredAccounts[0].name}} {{filteredAccounts[0].country.prefix}}</span>"
  </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TitleCustom',
  data () {
    return {
    }
  },
  async beforeMount () {
    try {
      await  this.getList('account')

      this.loading = true
    } catch (error) {}
  },
  computed: {
    ...mapGetters({
      accounts: 'getAccounts',
      teams: 'getTeams',
      session_account: 'getSessionAccount',
      session_team: 'getSessionTeam'
    }),
    filteredAccounts: function() {
      return this.accounts.filter((item) => {
        var account = this.session_account ? this.session_account : localStorage.session_account;
        if(item.id == account) {
          return item;
        }
      })
    },
    filteredTeams: function() {
      return this.teams.filter((item) => {
        var team = this.session_team ? this.session_team : localStorage.session_team;
        if(item.id == team) {
          return item;
        }
      })
    }
  },
  methods: {
    ...mapActions([
      'getList',
    ])
  },
}
</script>



// WEBPACK FOOTER //
// TitleCustom.vue?7565c71e